// Video popup functionality
const popupTriggers = document.querySelectorAll('.js-popup-trigger');
const popupBody = document.querySelector('.js-popup');

if (popupBody) {
  const popupClose = popupBody.querySelector('.custom-popup__close');
  const videoFrame = popupBody.querySelector('iframe');

  popupTriggers.forEach(popupTrigger => {
    const videoURL = popupTrigger.getAttribute('data-url');
      popupTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        
        popupBody.classList.add('is-opened');
        videoFrame.src = videoURL + '?autoplay=1';
      });
  });
  
  popupClose.addEventListener('click', () => {
    popupBody.classList.remove('is-opened');
    videoFrame.src = ''; 
  });
  
  window.addEventListener('click', (e) => {
    if (e.target === popupBody) {
      popupBody.classList.remove('is-opened');
      videoFrame.src = '';
    }
  });
}

// Color swatches
const swatches = document.querySelectorAll('.js-swatch');
swatches.forEach(function(swatch) {
  swatch.addEventListener('click', function(e) {
    e.preventDefault();
    const selector = `.produkt_select-open[data-option="${this.getAttribute('data-option')}"][data-option-index="${this.getAttribute('data-option-index')}"]`

    document.querySelector(selector).click();    
  })
})

// Product Countdown
const timerWrapper = document.querySelector('#product-countdown');

if (timerWrapper) {
  const COOKIE_NAME = "countdown_end";
  const HOURS_48 = 48 * 60 * 60 * 1000;

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(name, value, msFromNow) {
    const expires = new Date(Date.now() + msFromNow).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  let endTime = getCookie(COOKIE_NAME);

  if (!endTime) {
    endTime = Date.now() + HOURS_48;
    setCookie(COOKIE_NAME, endTime, HOURS_48);
  } else {
    endTime = parseInt(endTime);
  }

  function updateTimer() {
    const now = Date.now();
    const remaining = endTime - now;
    const timerElement = document.querySelector('.product-countdown__time');

    if (remaining <= 0) {
      document.querySelector('#product-countdown').classList.add('hidden')
      return;
    }

    const totalHours = Math.floor(remaining / (1000 * 60 * 60));
    timerElement.textContent = `${totalHours} hour${totalHours > 1 ? 's' : ''}`;

    requestAnimationFrame(updateTimer);
  }

  updateTimer();
}

// Features list
document.querySelectorAll('.product-block--features .js-show-more').forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault()
    
    if (button.classList.contains('clicked')) {
      button.textContent = 'Show More'
      button.classList.remove('clicked');
    } else {
      button.textContent = 'Show Less';
      button.classList.add('clicked');
    }

    const hiddenElements = document.querySelectorAll('.list-features .js-hidden');
    hiddenElements.forEach(element => {
      element.classList.contains('hidden') ? element.classList.remove('hidden') : element.classList.add('hidden')
    })
  })  
});

// Show filters
const filtersTrigger = document.querySelectorAll('.js-show-filters');
const bodyElement = document.querySelector('body');
const filtersDrawer = document.querySelector('.collection-filters');

filtersTrigger[0].addEventListener('click', function(e) {
  e.preventDefault();

  document.querySelectorAll('.kategorie_filter-grid .filter_content')[0].classList.toggle('active')
})

// Sort click
document.querySelector('.filter_header--sort').addEventListener('click', function() { 
  document.querySelector('.filter_inputs--sort').classList.toggle('active')
})

const sortCustomOptions = document.querySelectorAll('.js-sort')
sortCustomOptions.forEach(selector => {
  selector.addEventListener('click', function(e) {
    e.preventDefault();

    sortCustomOptions.forEach(link => link.classList.remove('is-active'))
    selector.classList.add('is-active')

    const dataValue = selector.getAttribute('data-value');
    const sortSelector = document.getElementById('field-2');

    sortSelector.value = dataValue;
    sortSelector.dispatchEvent(new Event('change'))
  })
})

